import type { UserType } from '../types';
import { getEmployeeRoute } from './employeeRoutes';

/** 登入後或 Logo 點擊時，各角色應進入的工作台路徑 */
export function getRoleDashboardPath(userType?: UserType | null): string {
  if (!userType) return '/';

  switch (userType) {
    case 'craftsman':
      return '/craftsman/dashboard';
    case 'company':
      return '/company/dashboard';
    case 'admin':
      return '/admin/dashboard';
    case 'customer':
      return '/customer/dashboard';
    case 'employee':
    case 'customer_service':
    case 'administrative_staff':
    case 'finance_staff':
    case 'other_staff':
      return getEmployeeRoute('dashboard', userType);
    default:
      return '/';
  }
}

/** 公司／工匠不應使用客戶端首頁 `/`（搜尋地圖） */
export function blocksPublicCustomerHome(userType?: UserType | null): boolean {
  return userType === 'company' || userType === 'craftsman';
}

/** Header Logo：已登入時導向角色首頁；未登入為公開首頁 */
export function getRoleLogoPath(userType?: UserType | null): string {
  if (!userType) return '/';
  if (blocksPublicCustomerHome(userType)) {
    return getRoleDashboardPath(userType);
  }
  if (userType === 'customer') return '/';
  return getRoleDashboardPath(userType);
}
